import { ICommand } from '@4r/mf-contracts-4services';

export type ClockCommand = ICommand & {
  id: string;
  typeId: string;
  eventTimestamp: string;
};

export const COMMAND_CLOCK_IN = 'ClockInCommand';
export const COMMAND_CLOCK_OUT = 'ClockOutCommand';
